/**
 * Variations Modal Component - Using new Modal component
 */
import React from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalTitle,
} from '../../components/ui/modal';
import { Button } from '../../components/ui/button';

export function VariationsModal({
  open,
  onOpenChange,
  product,
  formatCurrency,
  onSelect,
}) {
  if (!product) return null;

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContent size="sm">
        <ModalHeader>
          <ModalTitle>{product.name}</ModalTitle>
        </ModalHeader>
        <ModalBody className="space-y-2">
          <Button
            variant="outline"
            className="w-full justify-between h-14"
            onClick={() => onSelect(product)}
          >
            <span>Normal</span>
            <span className="font-mono font-bold">{formatCurrency(product.price)}</span>
          </Button>
          {product.variations?.map(variation => (
            <Button
              key={variation.id}
              variant="outline"
              className="w-full justify-between h-14"
              onClick={() => onSelect(product, variation)}
            >
              <span>{variation.name}</span>
              <span className="font-mono font-bold">
                {formatCurrency(product.price + variation.price_modifier)}
              </span>
            </Button>
          ))}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default VariationsModal;
